// extracted by mini-css-extract-plugin
module.exports = {"variantDropdown":"ProductTitle_variantDropdown__3w7hs","productModel":"ProductTitle_productModel__2XLpz","variantTitle":"ProductTitle_variantTitle__tZVR7"};